import * as React from 'react';
import {useTheme} from '@mui/material/styles';
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import {useEffect} from "react";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const MultiSelect = ({options, value, onChange, multiple, label}) => {
    const theme = useTheme();
    const [selectedOptions, setSelectedOption] = React.useState(value ?? []);

    const handleChange = (event) => {
        const {
            target: {value},
        } = event
        setSelectedOption(
            value
        );
        if (onChange) {
            onChange(event, {value, options});
        }
    };

    useEffect(() => {
        console.log('value geldi', value);
        setSelectedOption(value);
    }, [value]);
    console.log('selectedOptions', selectedOptions);
    return (
        <FormControl fullWidth={true} sx={{ minWidth: 120}}>
            {label && <InputLabel>{label}</InputLabel>}
            <Select
                multiple={multiple}
                value={selectedOptions ?? []}
                onChange={handleChange}
                input={<OutlinedInput label={label}/>}
                MenuProps={MenuProps}
                variant={'filled'}>
                {options.map((option) => (
                    <MenuItem
                        key={option.key}
                        value={option.value}
                    >
                        {option.text}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}
export default MultiSelect;